export const LANGUAGES = [
  { code: "fr", label: "Français" },
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
];

export const translations = {
  fr: {
    "header.dashboard": "Tableau de bord",
    "header.login": "Se connecter",
    "header.restaurantSpace": "Espace Restaurant",
    "header.logout": "Déconnexion",

    "hero.overline": "Les restaurants partenaires de Vytali",
    "hero.title1": "Trouvez votre prochain ",
    "hero.highlight": "repas",
    "hero.title2": " préféré.",
    "hero.subtitle": "Découvrez nos restaurants partenaires, explorez leurs menus et commandez en ligne en un clic.",
    "search.placeholder": "Rechercher un restaurant ou une cuisine…",

    "filters.all": "Tous",
    "filters.nearMe": "Près de moi",
    "filters.locating": "Localisation…",
    "filters.aroundMe": "Autour de moi",
    "sort.featured": "En vedette",
    "sort.rating": "Mieux notés",
    "sort.nearest": "Plus proche",
    "grid.loading": "Chargement…",
    "grid.noResults": "Aucun restaurant trouvé.",
    "footer.tagline": "Vitrine restaurants",

    "sections.popular.title": "Populaires cette semaine",
    "sections.popular.subtitle": "Nos partenaires les mieux notés en ce moment",
    "sections.new.title": "Nouveaux partenaires",
    "sections.new.subtitle": "Fraîchement débarqués chez Vytali",
    "sections.fast.title": "Livraison rapide",
    "sections.fast.subtitle": "Prêt à la porte en moins de 30 minutes",
    "sections.featured.title": "Coups de cœur Vytali",
    "sections.featured.subtitle": "Sélectionnés par notre équipe québécoise",
    "sections.cuisine.title": "Cuisine",
    "sections.all.title": "Tous nos partenaires",
    "sections.all.subtitle": "Explorez la totalité de la marketplace",

    "partnerBanner.eyebrow": "Restaurateur ou commerçant ?",
    "partnerBanner.title": "Rejoignez Vytali gratuitement",
    "partnerBanner.desc": "25 % de commission (dont 5 % de cashback pour vos clients). Livraison partout au Québec. Zéro engagement.",
    "partnerBanner.cta": "Devenir Partenaire",
    "partnerBanner.mobileCta": "Devenir Partenaire",

    "card.partner": "PARTENAIRE",
    "card.order": "Commander",

    "toast.nearMeSuccess": "Restaurants triés par proximité !",
    "toast.geoUnsupported": "La géolocalisation n'est pas supportée par ce navigateur.",
    "toast.geoDenied": "Impossible d'obtenir votre position. Autorisez la localisation.",

    "detail.back": "Retour",
    "detail.orderOnline": "Commander en ligne",
    "detail.menu": "Menu",
    "detail.menuSoon": "Menu bientôt disponible.",
    "detail.reviews": "Avis",
    "detail.yourRating": "Votre note",
    "detail.reviewPlaceholder": "Partagez votre expérience (optionnel)…",
    "detail.publishReview": "Publier mon avis",
    "detail.loginToReview": "Connectez-vous pour laisser un avis.",
    "detail.signIn": "Se connecter",
    "detail.noReviews": "Aucun avis pour le moment. Soyez le premier !",
    "detail.notFound": "Restaurant introuvable.",
    "toast.chooseRating": "Choisissez une note",
    "toast.thanksReview": "Merci pour votre avis !",
    "toast.error": "Une erreur est survenue",

    "clogin.welcome": "Bienvenue chez Vytali",
    "clogin.createAccount": "Créer un compte",
    "clogin.subtitleLogin": "Connectez-vous pour retrouver vos restaurants favoris.",
    "clogin.subtitleRegister": "Rejoignez Vytali pour commander plus vite.",
    "clogin.fullName": "Nom complet",
    "clogin.email": "Email",
    "clogin.password": "Mot de passe",
    "clogin.submitLogin": "Se connecter",
    "clogin.submitRegister": "Créer mon compte",
    "clogin.noAccount": "Pas encore de compte ?",
    "clogin.haveAccount": "Déjà inscrit ?",
    "clogin.signup": "S'inscrire",
    "clogin.signin": "Se connecter",
    "clogin.restaurantPrompt": "Vous êtes un restaurant ?",
    "toast.accountCreated": "Compte créé !",
    "toast.loginSuccess": "Connexion réussie !",

    "rauth.loginTitle": "Espace Restaurant",
    "rauth.registerTitle": "Rejoindre Vytali",
    "rauth.subtitleLogin": "Connectez-vous pour gérer votre menu et votre lien de commande.",
    "rauth.subtitleRegister": "Créez votre compte restaurant et publiez votre menu.",
    "rauth.restaurantName": "Nom du restaurant",
    "rauth.cuisine": "Type de cuisine (ex: Italien)",
    "rauth.submitLogin": "Se connecter",
    "rauth.submitRegister": "Créer mon compte",
    "rauth.noAccount": "Pas encore de compte ?",
    "rauth.haveAccount": "Déjà inscrit ?",
    "rauth.createAccount": "Créer un compte",
    "rauth.forgotPassword": "Mot de passe oublié ?",

    "forgot.back": "Retour à la connexion",
    "forgot.title": "Mot de passe oublié ?",
    "forgot.subtitle": "Entrez votre courriel et on vous envoie un lien pour créer un nouveau mot de passe.",
    "forgot.submit": "Envoyer le lien",
    "forgot.sentTitle": "Vérifiez vos courriels 📬",
    "forgot.sentDesc": "Si un compte existe avec cet email, vous recevrez un lien de réinitialisation dans les prochaines minutes. Vérifiez aussi vos spams.",
    "forgot.backToLogin": "Retour à la connexion",

    "reset.title": "Nouveau mot de passe",
    "reset.subtitle": "Choisissez un mot de passe d'au moins 8 caractères.",
    "reset.newPassword": "Nouveau mot de passe",
    "reset.confirmPassword": "Confirmez le mot de passe",
    "reset.submit": "Mettre à jour",
    "reset.tooShort": "Le mot de passe doit contenir au moins 8 caractères.",
    "reset.mismatch": "Les deux mots de passe ne correspondent pas.",
    "reset.missingToken": "Lien invalide — demandez un nouveau lien.",
    "reset.success": "Mot de passe mis à jour !",
    "reset.error": "Impossible de réinitialiser. Réessayez.",
    "reset.doneTitle": "C'est fait ! ✅",
    "reset.doneDesc": "Votre mot de passe a été mis à jour. On vous redirige vers la connexion…",
    "toast.restaurantCreated": "Compte restaurant créé !",

    "dash.restaurant": "Restaurant",
    "dash.viewPage": "Voir ma page",
    "dash.logout": "Déconnexion",
    "dash.title": "Tableau de bord",
    "dash.subtitle": "Gérez votre profil et votre menu.",
    "dash.profile": "Profil du restaurant",
    "dash.name": "Nom",
    "dash.cuisine": "Cuisine",
    "dash.description": "Description",
    "dash.imageUrl": "URL de l'image",
    "dash.city": "Ville",
    "dash.deliveryTime": "Temps (25-35 min)",
    "dash.priceRange": "Gamme de prix ($$)",
    "dash.address": "Adresse (pour la géolocalisation)",
    "dash.orderLink": "Lien de commande (UberEats, DoorDash…)",
    "dash.doordash": "Lien DoorDash",
    "dash.ubereats": "Lien UberEats",
    "dash.ownerName": "Nom du propriétaire",
    "dash.phone": "Numéro de téléphone",
    "dash.email": "Courriel du restaurant",
    "dash.itemPriceCad": "Prix ($ CAD)",
    "dash.priceRangeCad": "Fourchette de prix ($$)",
    "dash.itemImage": "URL de la photo du plat",
    "dash.pendingTitle": "Votre restaurant est en cours de validation",
    "dash.pendingDesc": "Il sera visible sur Vytali dès qu'il aura été approuvé par notre équipe. Vous pouvez déjà compléter votre profil et votre menu.",
    "dash.upload": "Téléverser",
    "dash.imageUploaded": "Photo téléversée",
    "dash.imageTooLarge": "Image trop lourde (max 5 Mo)",
    "dash.save": "Enregistrer",
    "dash.menu": "Menu",
    "dash.itemName": "Nom du plat",
    "dash.itemDescription": "Description",
    "dash.itemPrice": "Prix ($)",
    "dash.itemCategory": "Catégorie",
    "dash.addItem": "Ajouter au menu",
    "dash.noItems": "Aucun plat pour le moment.",
    "toast.profileUpdated": "Profil mis à jour",
    "toast.itemAdded": "Plat ajouté",
    "toast.itemDeleted": "Plat supprimé",

    "header.membership": "Membre Vytali",
    "mb.overline": "Carte Membre Virtuelle Vytali",
    "mb.title": "Devenez Membre Vytali",
    "mb.subtitle": "Une carte, des centaines d'avantages. Économisez chez tous nos commerces partenaires au Québec.",
    "mb.getCard": "Obtenir ma carte",
    "mb.memberSpace": "Espace Membre",
    "mb.walletNote": "Ajoutez votre carte à Apple Wallet & Google Wallet",
    "mb.securePay": "Paiement sécurisé sur vytalicartes.ca",
    "mb.b1t": "Promotions exclusives",
    "mb.b1d": "Accès à des centaines de promotions et offres chez nos commerces partenaires.",
    "mb.b2t": "Économies quotidiennes",
    "mb.b2d": "Économisez chaque jour sur vos repas, achats et activités.",
    "mb.b3t": "Cashback (bientôt)",
    "mb.b3d": "Le cashback arrive bientôt : vous cumulerez des récompenses sur vos commandes en ligne chez les restaurants partenaires Vytali.",
    "mb.b4t": "Dans votre portefeuille",
    "mb.b4d": "Votre carte toujours à portée de main sur Apple Wallet et Google Wallet.",
    "mb.ctaTitle": "Prêt à économiser ?",
    "mb.ctaText": "Rejoignez la communauté Vytali et profitez de tous les avantages dès aujourd'hui.",
    "mb.bannerTitle": "Carte Membre Vytali",
    "mb.bannerText": "Débloquez des promotions exclusives avec votre carte membre Vytali.",
    "mb.bannerCta": "Devenir membre",
    "mb.learnMore": "En savoir plus",
    "mbn.greeting": "Bonjour",
    "mbn.title": "Déjà membre Vytali ?",
    "mbn.walletLabel": "votre Carte Membre virtuelle est active",
    "mbn.comingSoon": "Cashback bientôt disponible chez nos partenaires",
    "mbn.perk": "Carte Membre virtuelle Vytali",
    "map.show": "Voir la carte",
    "map.hide": "Masquer la carte",
    "map.view": "Voir",
    "map.youAreHere": "Vous êtes ici",
    "mbn.cta": "Activer ma carte",

    "chat.title": "Assistant Vytali",
    "chat.subtitle": "En ligne · réponse immédiate",
    "chat.welcome": "Bonjour ! 👋 Je suis l'assistant Vytali. Dites-moi ce que vous cherchez (type de cuisine, ville…) et je vous oriente vers nos partenaires.",
    "chat.placeholder": "Écrivez votre message…",
    "chat.openLabel": "Discuter avec nous",
    "chat.error": "Assistant momentanément indisponible. Réessayez.",

    "header.partners": "Devenir Partenaire",

    "partners.hero.badge": "Ouvert aux restaurants, épiceries, traiteurs et cafés du Québec",
    "partners.hero.title1": "Devenez partenaire ",
    "partners.hero.highlight": "Vytali",
    "partners.hero.title2": ".",
    "partners.hero.subtitle": "L'alternative québécoise à UberEats & DoorDash. Commande en ligne, livraison partout au Québec, et 5 % de cashback qui fait revenir vos clients — encore et encore.",
    "partners.hero.cta": "Rejoindre gratuitement",
    "partners.hero.social": "26 commerces partenaires · Livraison partout au Québec · POS Clover intégré",

    "partners.compare.title": "Vytali vs les géants américains",
    "partners.compare.subtitle": "Comparez ce que vous obtenez vraiment, commande après commande.",
    "partners.compare.metric": "Métrique",
    "partners.compare.vytali": "Vytali",
    "partners.compare.uber": "UberEats",
    "partners.compare.door": "DoorDash",
    "partners.compare.commission": "Commission par commande",
    "partners.compare.cashback": "Cashback reversé au client",
    "partners.compare.effective": "Coût effectif (net)",
    "partners.compare.retention": "Fidélisation client (1 an)",
    "partners.compare.money": "Argent qui reste au Québec 🇨🇦",
    "partners.compare.support": "Support 100% en français",
    "partners.compare.multi": "Multilingue FR / EN / ES",
    "partners.compare.delivery": "Livraison partout au Québec",
    "partners.compare.footnote": "Estimation basée sur études de fidélisation e-commerce et sur des programmes de cashback comparables (Rakuten, Fidélis). Résultats variables selon volume, catégorie et localisation.",
    "partners.compare.revenueTitle": "Sur 100 commandes de 100$ / an",
    "partners.compare.revenueVytali": "Vytali net",
    "partners.compare.revenueUber": "UberEats net",
    "partners.compare.revenueDelta": "+39 % de revenu net grâce au cashback",

    "partners.flywheel.title": "Le pouvoir du cashback Vytali",
    "partners.flywheel.subtitle": "5 % de chaque commande revient dans la Carte Vytali de votre client. Il revient. Vous gagnez plus.",
    "partners.flywheel.s1t": "1. Le client commande chez vous",
    "partners.flywheel.s1d": "Il utilise vytalicartes.ca pour passer sa commande de 30 $.",
    "partners.flywheel.s2t": "2. Il gagne 1,50 $ de cashback",
    "partners.flywheel.s2d": "5 % du montant est crédité automatiquement sur sa Carte Membre Vytali.",
    "partners.flywheel.s3t": "3. Il revient utiliser son cashback",
    "partners.flywheel.s3d": "Motivé par son solde, il revient commander chez vous 2-3 fois plus vite.",
    "partners.flywheel.s4t": "4. Vous multipliez vos revenus",
    "partners.flywheel.s4d": "Volume de commandes en hausse · relation client durable · zéro dépendance aux géants US.",

    "partners.how.title": "Comment ça marche",
    "partners.how.subtitle": "En ligne en 48 heures. Sans code. Sans engagement.",
    "partners.how.s1t": "Inscription gratuite",
    "partners.how.s1d": "Remplissez le formulaire ci-dessous. 2 minutes suffisent.",
    "partners.how.s2t": "On valide votre profil",
    "partners.how.s2d": "Notre équipe québécoise vous appelle sous 24h pour finaliser.",
    "partners.how.s3t": "Personnalisez votre vitrine",
    "partners.how.s3d": "Photos, menu, horaires — le tout sur un tableau de bord simple.",
    "partners.how.s4t": "Recevez commandes & livraisons",
    "partners.how.s4d": "Directement sur votre POS Clover. Vytali gère la livraison via son réseau.",

    "partners.benefits.title": "6 bonnes raisons de rejoindre Vytali",
    "partners.b1t": "Commission juste : 25 %",
    "partners.b1d": "Dont 5 % de cashback qui revient chez VOS clients. Coût net effectif : 20 %, contre 30 % chez UberEats.",
    "partners.b2t": "Livraison incluse partout au Québec",
    "partners.b2d": "On s'appuie sur un réseau de livraison éprouvé pour desservir toutes vos zones — vous n'avez rien à gérer.",
    "partners.b3t": "100 % québécois",
    "partners.b3d": "Équipe locale, support en français, argent qui reste ici. Pas de bureau central au Texas.",
    "partners.b4t": "Cashback qui fidélise vos clients",
    "partners.b4d": "Vos clients gagnent 5 % à chaque commande — ils reviennent commander CHEZ VOUS, pas ailleurs.",
    "partners.b5t": "Multilingue FR / EN / ES",
    "partners.b5d": "Touristes, expatriés, résidents : votre vitrine s'adapte à leur langue automatiquement.",
    "partners.b6t": "Dashboard simple, POS Clover",
    "partners.b6d": "Téléversez vos photos, modifiez votre menu en 2 clics. Commandes reçues directement sur votre Clover.",

    "partners.trust.title": "Ils nous font déjà confiance",
    "partners.trust.subtitle": "Une communauté grandissante de commerces québécois.",

    "partners.form.title": "Rejoignez Vytali",
    "partners.form.subtitle": "Remplissez le formulaire — on vous appelle sous 24 heures.",
    "partners.form.businessName": "Nom du commerce",
    "partners.form.businessType": "Type de commerce",
    "partners.form.type.restaurant": "Restaurant",
    "partners.form.type.epicerie": "Épicerie",
    "partners.form.type.traiteur": "Traiteur",
    "partners.form.type.cafe_bar": "Café / Bar",
    "partners.form.type.autre": "Autre (food)",
    "partners.form.address": "Adresse",
    "partners.form.city": "Ville",
    "partners.form.contactName": "Votre nom",
    "partners.form.phone": "Téléphone",
    "partners.form.email": "Courriel",
    "partners.form.website": "Site web ou Instagram (optionnel)",
    "partners.form.message": "Parlez-nous de votre commerce (optionnel)",
    "partners.form.submit": "Envoyer ma candidature",
    "partners.form.submitting": "Envoi en cours…",
    "partners.form.success": "Candidature envoyée ! On vous contacte sous 24h.",
    "partners.form.error": "Impossible d'envoyer. Vérifiez les champs.",
    "partners.form.rateLimited": "Trop de tentatives. Réessayez dans une heure.",

    "partners.faq.title": "Questions fréquentes",
    "partners.faq.q1": "Combien coûte l'inscription ?",
    "partners.faq.a1": "L'inscription est 100 % gratuite. On ne prélève de commission que sur les commandes reçues via Vytali (25 %, dont 5 % revient à vos clients en cashback).",
    "partners.faq.q2": "En combien de temps mon commerce est-il en ligne ?",
    "partners.faq.a2": "24 à 48h après votre candidature. Notre équipe québécoise vous appelle pour valider, on branche votre POS Clover, et vous êtes visible sur vytalicartes.ca.",
    "partners.faq.q3": "Puis-je garder UberEats et DoorDash en parallèle ?",
    "partners.faq.a3": "Oui, totalement. Vytali est complémentaire. Beaucoup de nos partenaires gardent les géants US pour leur trafic, et utilisent Vytali pour bâtir leur base de clients fidèles au Québec.",
    "partners.faq.q4": "Comment fonctionne la livraison ?",
    "partners.faq.a4": "Vytali couvre tout le Québec grâce à un réseau de livraison éprouvé (partenariat opérationnel). Vous n'avez ni livreur à embaucher, ni logistique à gérer.",
    "partners.faq.q5": "Comment est calculé le cashback client ?",
    "partners.faq.a5": "5 % du montant HT de chaque commande passée sur vytalicartes.ca est automatiquement crédité sur la Carte Membre Vytali du client. Ce cashback est financé par notre commission, pas par vous.",
    "partners.faq.q6": "Est-ce que je garde le contrôle de mes prix ?",
    "partners.faq.a6": "Oui. Vous fixez vos prix, vos menus, vos horaires. Vytali n'impose ni promotion forcée ni prix minimum.",

    "partners.finalcta.title": "Prêt à passer au niveau supérieur ?",
    "partners.finalcta.subtitle": "Rejoignez la seule marketplace de commande & livraison 100 % québécoise.",
    "partners.finalcta.button": "Rejoindre Vytali maintenant",

    "admin.tabs.applications": "Candidatures",
    "admin.applications.empty": "Aucune candidature pour le moment.",
    "admin.applications.contact": "Marquer contacté",
    "admin.applications.approve": "Approuver",
    "admin.applications.reject": "Rejeter",
    "admin.applications.reset": "Remettre en attente",
  },
  en: {
    "header.dashboard": "Dashboard",
    "header.login": "Sign in",
    "header.restaurantSpace": "Restaurant Portal",
    "header.logout": "Log out",

    "hero.overline": "Vytali's partner restaurants",
    "hero.title1": "Find your next favorite ",
    "hero.highlight": "meal",
    "hero.title2": ".",
    "hero.subtitle": "Discover our partner restaurants, explore their menus and order online in one click.",
    "search.placeholder": "Search a restaurant or a cuisine…",

    "filters.all": "All",
    "filters.nearMe": "Near me",
    "filters.locating": "Locating…",
    "filters.aroundMe": "Around me",
    "sort.featured": "Featured",
    "sort.rating": "Top rated",
    "sort.nearest": "Nearest",
    "grid.loading": "Loading…",
    "grid.noResults": "No restaurant found.",
    "footer.tagline": "Restaurant showcase",

    "sections.popular.title": "Popular this week",
    "sections.popular.subtitle": "Our highest-rated partners right now",
    "sections.new.title": "New partners",
    "sections.new.subtitle": "Freshly onboarded on Vytali",
    "sections.fast.title": "Fast delivery",
    "sections.fast.subtitle": "At your door in under 30 minutes",
    "sections.featured.title": "Vytali picks",
    "sections.featured.subtitle": "Hand-selected by our Quebec team",
    "sections.cuisine.title": "Cuisine",
    "sections.all.title": "All our partners",
    "sections.all.subtitle": "Browse the whole marketplace",

    "partnerBanner.eyebrow": "Restaurant owner or merchant?",
    "partnerBanner.title": "Join Vytali for free",
    "partnerBanner.desc": "25% commission (5% of which goes as cashback to your customers). Delivery across Quebec. Zero commitment.",
    "partnerBanner.cta": "Become a Partner",
    "partnerBanner.mobileCta": "Become a Partner",

    "card.partner": "PARTNER",
    "card.order": "Order",

    "toast.nearMeSuccess": "Restaurants sorted by distance!",
    "toast.geoUnsupported": "Geolocation is not supported by this browser.",
    "toast.geoDenied": "Couldn't get your location. Please allow location access.",

    "detail.back": "Back",
    "detail.orderOnline": "Order online",
    "detail.menu": "Menu",
    "detail.menuSoon": "Menu coming soon.",
    "detail.reviews": "Reviews",
    "detail.yourRating": "Your rating",
    "detail.reviewPlaceholder": "Share your experience (optional)…",
    "detail.publishReview": "Post my review",
    "detail.loginToReview": "Sign in to leave a review.",
    "detail.signIn": "Sign in",
    "detail.noReviews": "No reviews yet. Be the first!",
    "detail.notFound": "Restaurant not found.",
    "toast.chooseRating": "Please choose a rating",
    "toast.thanksReview": "Thanks for your review!",
    "toast.error": "Something went wrong",

    "clogin.welcome": "Welcome to Vytali",
    "clogin.createAccount": "Create an account",
    "clogin.subtitleLogin": "Sign in to find your favorite restaurants.",
    "clogin.subtitleRegister": "Join Vytali to order faster.",
    "clogin.fullName": "Full name",
    "clogin.email": "Email",
    "clogin.password": "Password",
    "clogin.submitLogin": "Sign in",
    "clogin.submitRegister": "Create my account",
    "clogin.noAccount": "No account yet?",
    "clogin.haveAccount": "Already registered?",
    "clogin.signup": "Sign up",
    "clogin.signin": "Sign in",
    "clogin.restaurantPrompt": "Are you a restaurant?",
    "toast.accountCreated": "Account created!",
    "toast.loginSuccess": "Signed in!",

    "rauth.loginTitle": "Restaurant Portal",
    "rauth.registerTitle": "Join Vytali",
    "rauth.subtitleLogin": "Sign in to manage your menu and order link.",
    "rauth.subtitleRegister": "Create your restaurant account and publish your menu.",
    "rauth.restaurantName": "Restaurant name",
    "rauth.cuisine": "Cuisine type (e.g. Italian)",
    "rauth.submitLogin": "Sign in",
    "rauth.submitRegister": "Create my account",
    "rauth.noAccount": "No account yet?",
    "rauth.haveAccount": "Already registered?",
    "rauth.createAccount": "Create an account",
    "rauth.forgotPassword": "Forgot password?",

    "forgot.back": "Back to sign in",
    "forgot.title": "Forgot password?",
    "forgot.subtitle": "Enter your email and we'll send you a link to create a new password.",
    "forgot.submit": "Send the link",
    "forgot.sentTitle": "Check your inbox 📬",
    "forgot.sentDesc": "If an account exists with that email, you'll receive a reset link within a few minutes. Please also check your spam folder.",
    "forgot.backToLogin": "Back to sign in",

    "reset.title": "New password",
    "reset.subtitle": "Choose a password of at least 8 characters.",
    "reset.newPassword": "New password",
    "reset.confirmPassword": "Confirm password",
    "reset.submit": "Update",
    "reset.tooShort": "Password must be at least 8 characters.",
    "reset.mismatch": "Passwords do not match.",
    "reset.missingToken": "Invalid link — please request a new one.",
    "reset.success": "Password updated!",
    "reset.error": "Reset failed. Please try again.",
    "reset.doneTitle": "All set! ✅",
    "reset.doneDesc": "Your password has been updated. Redirecting to sign in…",
    "toast.restaurantCreated": "Restaurant account created!",

    "dash.restaurant": "Restaurant",
    "dash.viewPage": "View my page",
    "dash.logout": "Log out",
    "dash.title": "Dashboard",
    "dash.subtitle": "Manage your profile and menu.",
    "dash.profile": "Restaurant profile",
    "dash.name": "Name",
    "dash.cuisine": "Cuisine",
    "dash.description": "Description",
    "dash.imageUrl": "Image URL",
    "dash.city": "City",
    "dash.deliveryTime": "Time (25-35 min)",
    "dash.priceRange": "Price range ($$)",
    "dash.address": "Address (for geolocation)",
    "dash.orderLink": "Order link (UberEats, DoorDash…)",
    "dash.doordash": "DoorDash link",
    "dash.ubereats": "UberEats link",
    "dash.ownerName": "Owner name",
    "dash.phone": "Phone number",
    "dash.email": "Restaurant email",
    "dash.itemPriceCad": "Price ($ CAD)",
    "dash.priceRangeCad": "Price range ($$)",
    "dash.itemImage": "Dish photo URL",
    "dash.pendingTitle": "Your restaurant is being reviewed",
    "dash.pendingDesc": "It will appear on Vytali as soon as our team approves it. You can already complete your profile and menu.",
    "dash.upload": "Upload",
    "dash.imageUploaded": "Photo uploaded",
    "dash.imageTooLarge": "Image too large (max 5 MB)",
    "dash.save": "Save",
    "dash.menu": "Menu",
    "dash.itemName": "Dish name",
    "dash.itemDescription": "Description",
    "dash.itemPrice": "Price ($)",
    "dash.itemCategory": "Category",
    "dash.addItem": "Add to menu",
    "dash.noItems": "No dishes yet.",
    "toast.profileUpdated": "Profile updated",
    "toast.itemAdded": "Dish added",
    "toast.itemDeleted": "Dish removed",

    "header.membership": "Vytali Member",
    "mb.overline": "Vytali Virtual Membership Card",
    "mb.title": "Become a Vytali Member",
    "mb.subtitle": "One card, hundreds of perks. Save at all our partner merchants across Quebec.",
    "mb.getCard": "Get my card",
    "mb.memberSpace": "Member Area",
    "mb.walletNote": "Add your card to Apple Wallet & Google Wallet",
    "mb.securePay": "Secure payment on vytalicartes.ca",
    "mb.b1t": "Exclusive promotions",
    "mb.b1d": "Access hundreds of promotions and offers at our partner merchants.",
    "mb.b2t": "Daily savings",
    "mb.b2d": "Save every day on your meals, shopping and activities.",
    "mb.b3t": "Cashback (coming soon)",
    "mb.b3d": "Cashback is coming soon: you'll earn rewards on your online orders at every Vytali partner restaurant.",
    "mb.b4t": "In your wallet",
    "mb.b4d": "Your card always at hand on Apple Wallet and Google Wallet.",
    "mb.ctaTitle": "Ready to save?",
    "mb.ctaText": "Join the Vytali community and enjoy all the perks today.",
    "mb.bannerTitle": "Vytali Membership Card",
    "mb.bannerText": "Unlock exclusive promotions with your Vytali membership card.",
    "mb.bannerCta": "Become a member",
    "mb.learnMore": "Learn more",
    "mbn.greeting": "Hello",
    "mbn.title": "Already a Vytali member?",
    "mbn.walletLabel": "your virtual Member Card is active",
    "mbn.comingSoon": "Cashback coming soon at our partners",
    "mbn.perk": "Vytali Virtual Member Card",
    "map.show": "Show map",
    "map.hide": "Hide map",
    "map.view": "View",
    "map.youAreHere": "You are here",
    "mbn.cta": "Activate my card",

    "chat.title": "Vytali Assistant",
    "chat.subtitle": "Online · instant reply",
    "chat.welcome": "Hi! 👋 I'm the Vytali assistant. Tell me what you're looking for (cuisine, city…) and I'll point you to our partners.",
    "chat.placeholder": "Type your message…",
    "chat.openLabel": "Chat with us",
    "chat.error": "Assistant temporarily unavailable. Please try again.",

    "header.partners": "Become a Partner",

    "partners.hero.badge": "Open to restaurants, groceries, caterers and cafés across Quebec",
    "partners.hero.title1": "Become a ",
    "partners.hero.highlight": "Vytali",
    "partners.hero.title2": " partner.",
    "partners.hero.subtitle": "The Quebec-born alternative to UberEats & DoorDash. Online ordering, delivery across Quebec, and 5% cashback that keeps your customers coming back.",
    "partners.hero.cta": "Join for free",
    "partners.hero.social": "26 partner merchants · Delivery across Quebec · Clover POS integrated",

    "partners.compare.title": "Vytali vs the American giants",
    "partners.compare.subtitle": "Compare what you actually get, order after order.",
    "partners.compare.metric": "Metric",
    "partners.compare.vytali": "Vytali",
    "partners.compare.uber": "UberEats",
    "partners.compare.door": "DoorDash",
    "partners.compare.commission": "Commission per order",
    "partners.compare.cashback": "Cashback to customer",
    "partners.compare.effective": "Effective net cost",
    "partners.compare.retention": "Customer retention (1 year)",
    "partners.compare.money": "Money stays in Quebec 🇨🇦",
    "partners.compare.support": "100% French-speaking support",
    "partners.compare.multi": "Multilingual FR / EN / ES",
    "partners.compare.delivery": "Delivery across Quebec",
    "partners.compare.footnote": "Estimate based on e-commerce retention studies and comparable cashback programs (Rakuten, Fidélis). Results vary depending on volume, category and location.",
    "partners.compare.revenueTitle": "Over 100 orders of $100 / year",
    "partners.compare.revenueVytali": "Vytali net",
    "partners.compare.revenueUber": "UberEats net",
    "partners.compare.revenueDelta": "+39% net revenue thanks to cashback",

    "partners.flywheel.title": "The power of Vytali cashback",
    "partners.flywheel.subtitle": "5% of every order goes back into your customer's Vytali Card. They come back. You earn more.",
    "partners.flywheel.s1t": "1. Customer orders from you",
    "partners.flywheel.s1d": "They use vytalicartes.ca to place a $30 order.",
    "partners.flywheel.s2t": "2. They earn $1.50 cashback",
    "partners.flywheel.s2d": "5% of the amount is automatically credited to their Vytali Member Card.",
    "partners.flywheel.s3t": "3. They come back to use it",
    "partners.flywheel.s3d": "Motivated by their balance, they reorder from you 2-3x faster.",
    "partners.flywheel.s4t": "4. Your revenue multiplies",
    "partners.flywheel.s4d": "Higher order volume · lasting customer relationship · zero dependence on US giants.",

    "partners.how.title": "How it works",
    "partners.how.subtitle": "Online in 48 hours. No code. No commitment.",
    "partners.how.s1t": "Free sign-up",
    "partners.how.s1d": "Fill out the form below. 2 minutes is all it takes.",
    "partners.how.s2t": "We validate your profile",
    "partners.how.s2d": "Our Quebec team calls you within 24h to finalize.",
    "partners.how.s3t": "Customize your storefront",
    "partners.how.s3d": "Photos, menu, opening hours — all on a simple dashboard.",
    "partners.how.s4t": "Get orders & deliveries",
    "partners.how.s4d": "Straight to your Clover POS. Vytali handles the delivery.",

    "partners.benefits.title": "6 great reasons to join Vytali",
    "partners.b1t": "Fair commission: 25%",
    "partners.b1d": "Of which 5% flows back to YOUR customers. Effective net cost: 20%, versus 30% at UberEats.",
    "partners.b2t": "Delivery included across Quebec",
    "partners.b2d": "We rely on a proven delivery network to reach all your zones — you handle nothing.",
    "partners.b3t": "100% Quebec-based",
    "partners.b3d": "Local team, French-speaking support, money stays here. No head office in Texas.",
    "partners.b4t": "Cashback that fuels loyalty",
    "partners.b4d": "Customers earn 5% on every order — they come back to YOU, not to someone else.",
    "partners.b5t": "Multilingual FR / EN / ES",
    "partners.b5d": "Tourists, expats, residents: your storefront speaks their language automatically.",
    "partners.b6t": "Simple dashboard + Clover POS",
    "partners.b6d": "Upload photos, edit your menu in 2 clicks. Orders land straight on your Clover.",

    "partners.trust.title": "They already trust us",
    "partners.trust.subtitle": "A growing community of Quebec merchants.",

    "partners.form.title": "Join Vytali",
    "partners.form.subtitle": "Fill out the form — we'll call you within 24 hours.",
    "partners.form.businessName": "Business name",
    "partners.form.businessType": "Business type",
    "partners.form.type.restaurant": "Restaurant",
    "partners.form.type.epicerie": "Grocery",
    "partners.form.type.traiteur": "Caterer",
    "partners.form.type.cafe_bar": "Café / Bar",
    "partners.form.type.autre": "Other (food)",
    "partners.form.address": "Address",
    "partners.form.city": "City",
    "partners.form.contactName": "Your name",
    "partners.form.phone": "Phone",
    "partners.form.email": "Email",
    "partners.form.website": "Website or Instagram (optional)",
    "partners.form.message": "Tell us about your business (optional)",
    "partners.form.submit": "Send my application",
    "partners.form.submitting": "Sending…",
    "partners.form.success": "Application sent! We'll contact you within 24h.",
    "partners.form.error": "Could not send. Please check the fields.",
    "partners.form.rateLimited": "Too many attempts. Please try again in an hour.",

    "partners.faq.title": "Frequently asked questions",
    "partners.faq.q1": "How much does it cost to sign up?",
    "partners.faq.a1": "Sign-up is 100% free. We only take a commission on orders received through Vytali (25%, of which 5% goes back to your customers as cashback).",
    "partners.faq.q2": "How fast can my business go live?",
    "partners.faq.a2": "24 to 48h after your application. Our Quebec team calls you, we connect your Clover POS, and you appear on vytalicartes.ca.",
    "partners.faq.q3": "Can I keep UberEats & DoorDash in parallel?",
    "partners.faq.a3": "Yes, fully. Vytali is complementary. Many of our partners keep the US giants for traffic, and use Vytali to build a loyal Quebec customer base.",
    "partners.faq.q4": "How does the delivery work?",
    "partners.faq.a4": "Vytali covers all of Quebec through a proven delivery network. No drivers to hire, no logistics to manage.",
    "partners.faq.q5": "How is the customer cashback calculated?",
    "partners.faq.a5": "5% of the pre-tax amount of every order placed on vytalicartes.ca is automatically credited to the customer's Vytali Member Card. This cashback is funded by our commission, not by you.",
    "partners.faq.q6": "Do I keep control of my pricing?",
    "partners.faq.a6": "Yes. You set your prices, menus, opening hours. Vytali never imposes a forced promotion or a minimum price.",

    "partners.finalcta.title": "Ready to level up?",
    "partners.finalcta.subtitle": "Join the only 100% Quebec-based order & delivery marketplace.",
    "partners.finalcta.button": "Join Vytali now",

    "admin.tabs.applications": "Applications",
    "admin.applications.empty": "No applications yet.",
    "admin.applications.contact": "Mark contacted",
    "admin.applications.approve": "Approve",
    "admin.applications.reject": "Reject",
    "admin.applications.reset": "Reset to pending",
  },
  es: {
    "header.dashboard": "Panel",
    "header.login": "Iniciar sesión",
    "header.restaurantSpace": "Portal Restaurante",
    "header.logout": "Cerrar sesión",

    "hero.overline": "Los restaurantes asociados de Vytali",
    "hero.title1": "Encuentra tu próxima comida ",
    "hero.highlight": "favorita",
    "hero.title2": ".",
    "hero.subtitle": "Descubre nuestros restaurantes asociados, explora sus menús y pide en línea con un clic.",
    "search.placeholder": "Buscar un restaurante o una cocina…",

    "filters.all": "Todos",
    "filters.nearMe": "Cerca de mí",
    "filters.locating": "Localizando…",
    "filters.aroundMe": "A mi alrededor",
    "sort.featured": "Destacados",
    "sort.rating": "Mejor valorados",
    "sort.nearest": "Más cercano",
    "grid.loading": "Cargando…",
    "grid.noResults": "No se encontró ningún restaurante.",
    "footer.tagline": "Vitrina de restaurantes",

    "sections.popular.title": "Populares esta semana",
    "sections.popular.subtitle": "Nuestros socios mejor valorados",
    "sections.new.title": "Nuevos socios",
    "sections.new.subtitle": "Recién llegados a Vytali",
    "sections.fast.title": "Entrega rápida",
    "sections.fast.subtitle": "En tu puerta en menos de 30 minutos",
    "sections.featured.title": "Selección Vytali",
    "sections.featured.subtitle": "Elegidos por nuestro equipo quebequense",
    "sections.cuisine.title": "Cocina",
    "sections.all.title": "Todos nuestros socios",
    "sections.all.subtitle": "Explora toda la marketplace",

    "partnerBanner.eyebrow": "¿Restaurante o comercio?",
    "partnerBanner.title": "Únete a Vytali gratis",
    "partnerBanner.desc": "25 % de comisión (5 % vuelve como cashback a tus clientes). Entrega en todo Quebec. Cero compromiso.",
    "partnerBanner.cta": "Ser Socio",
    "partnerBanner.mobileCta": "Ser Socio",

    "card.partner": "SOCIO",
    "card.order": "Pedir",

    "toast.nearMeSuccess": "¡Restaurantes ordenados por proximidad!",
    "toast.geoUnsupported": "La geolocalización no es compatible con este navegador.",
    "toast.geoDenied": "No se pudo obtener tu ubicación. Permite el acceso a la ubicación.",

    "detail.back": "Volver",
    "detail.orderOnline": "Pedir en línea",
    "detail.menu": "Menú",
    "detail.menuSoon": "Menú próximamente.",
    "detail.reviews": "Reseñas",
    "detail.yourRating": "Tu valoración",
    "detail.reviewPlaceholder": "Comparte tu experiencia (opcional)…",
    "detail.publishReview": "Publicar mi reseña",
    "detail.loginToReview": "Inicia sesión para dejar una reseña.",
    "detail.signIn": "Iniciar sesión",
    "detail.noReviews": "Aún no hay reseñas. ¡Sé el primero!",
    "detail.notFound": "Restaurante no encontrado.",
    "toast.chooseRating": "Elige una valoración",
    "toast.thanksReview": "¡Gracias por tu reseña!",
    "toast.error": "Ocurrió un error",

    "clogin.welcome": "Bienvenido a Vytali",
    "clogin.createAccount": "Crear una cuenta",
    "clogin.subtitleLogin": "Inicia sesión para encontrar tus restaurantes favoritos.",
    "clogin.subtitleRegister": "Únete a Vytali para pedir más rápido.",
    "clogin.fullName": "Nombre completo",
    "clogin.email": "Correo electrónico",
    "clogin.password": "Contraseña",
    "clogin.submitLogin": "Iniciar sesión",
    "clogin.submitRegister": "Crear mi cuenta",
    "clogin.noAccount": "¿Aún no tienes cuenta?",
    "clogin.haveAccount": "¿Ya estás registrado?",
    "clogin.signup": "Registrarse",
    "clogin.signin": "Iniciar sesión",
    "clogin.restaurantPrompt": "¿Eres un restaurante?",
    "toast.accountCreated": "¡Cuenta creada!",
    "toast.loginSuccess": "¡Sesión iniciada!",

    "rauth.loginTitle": "Portal Restaurante",
    "rauth.registerTitle": "Unirse a Vytali",
    "rauth.subtitleLogin": "Inicia sesión para gestionar tu menú y tu enlace de pedidos.",
    "rauth.subtitleRegister": "Crea tu cuenta de restaurante y publica tu menú.",
    "rauth.restaurantName": "Nombre del restaurante",
    "rauth.cuisine": "Tipo de cocina (ej: Italiana)",
    "rauth.submitLogin": "Iniciar sesión",
    "rauth.submitRegister": "Crear mi cuenta",
    "rauth.noAccount": "¿Aún no tienes cuenta?",
    "rauth.haveAccount": "¿Ya estás registrado?",
    "rauth.createAccount": "Crear una cuenta",
    "rauth.forgotPassword": "¿Contraseña olvidada?",

    "forgot.back": "Volver al inicio de sesión",
    "forgot.title": "¿Contraseña olvidada?",
    "forgot.subtitle": "Ingresa tu correo y te enviamos un enlace para crear una nueva contraseña.",
    "forgot.submit": "Enviar el enlace",
    "forgot.sentTitle": "Revisa tu bandeja 📬",
    "forgot.sentDesc": "Si existe una cuenta con ese correo, recibirás un enlace de restablecimiento en unos minutos. Revisa también la carpeta de spam.",
    "forgot.backToLogin": "Volver al inicio de sesión",

    "reset.title": "Nueva contraseña",
    "reset.subtitle": "Elige una contraseña de al menos 8 caracteres.",
    "reset.newPassword": "Nueva contraseña",
    "reset.confirmPassword": "Confirmar contraseña",
    "reset.submit": "Actualizar",
    "reset.tooShort": "La contraseña debe tener al menos 8 caracteres.",
    "reset.mismatch": "Las contraseñas no coinciden.",
    "reset.missingToken": "Enlace inválido — solicita uno nuevo.",
    "reset.success": "¡Contraseña actualizada!",
    "reset.error": "No se pudo restablecer. Vuelve a intentar.",
    "reset.doneTitle": "¡Listo! ✅",
    "reset.doneDesc": "Tu contraseña ha sido actualizada. Redirigiendo al inicio de sesión…",
    "toast.restaurantCreated": "¡Cuenta de restaurante creada!",

    "dash.restaurant": "Restaurante",
    "dash.viewPage": "Ver mi página",
    "dash.logout": "Cerrar sesión",
    "dash.title": "Panel",
    "dash.subtitle": "Gestiona tu perfil y tu menú.",
    "dash.profile": "Perfil del restaurante",
    "dash.name": "Nombre",
    "dash.cuisine": "Cocina",
    "dash.description": "Descripción",
    "dash.imageUrl": "URL de la imagen",
    "dash.city": "Ciudad",
    "dash.deliveryTime": "Tiempo (25-35 min)",
    "dash.priceRange": "Rango de precios ($$)",
    "dash.address": "Dirección (para la geolocalización)",
    "dash.orderLink": "Enlace de pedidos (UberEats, DoorDash…)",
    "dash.doordash": "Enlace DoorDash",
    "dash.ubereats": "Enlace UberEats",
    "dash.ownerName": "Nombre del propietario",
    "dash.phone": "Número de teléfono",
    "dash.email": "Correo del restaurante",
    "dash.itemPriceCad": "Precio ($ CAD)",
    "dash.priceRangeCad": "Rango de precios ($$)",
    "dash.itemImage": "URL de la foto del plato",
    "dash.pendingTitle": "Tu restaurante está en revisión",
    "dash.pendingDesc": "Aparecerá en Vytali en cuanto nuestro equipo lo apruebe. Ya puedes completar tu perfil y tu menú.",
    "dash.upload": "Subir",
    "dash.imageUploaded": "Foto subida",
    "dash.imageTooLarge": "Imagen demasiado grande (máx 5 MB)",
    "dash.save": "Guardar",
    "dash.menu": "Menú",
    "dash.itemName": "Nombre del plato",
    "dash.itemDescription": "Descripción",
    "dash.itemPrice": "Precio ($)",
    "dash.itemCategory": "Categoría",
    "dash.addItem": "Añadir al menú",
    "dash.noItems": "Aún no hay platos.",
    "toast.profileUpdated": "Perfil actualizado",
    "toast.itemAdded": "Plato añadido",
    "toast.itemDeleted": "Plato eliminado",

    "header.membership": "Miembro Vytali",
    "mb.overline": "Tarjeta de Miembro Virtual Vytali",
    "mb.title": "Hazte Miembro Vytali",
    "mb.subtitle": "Una tarjeta, cientos de ventajas. Ahorra en todos nuestros comercios asociados en Quebec.",
    "mb.getCard": "Obtener mi tarjeta",
    "mb.memberSpace": "Área de Miembros",
    "mb.walletNote": "Añade tu tarjeta a Apple Wallet y Google Wallet",
    "mb.securePay": "Pago seguro en vytalicartes.ca",
    "mb.b1t": "Promociones exclusivas",
    "mb.b1d": "Accede a cientos de promociones y ofertas en nuestros comercios asociados.",
    "mb.b2t": "Ahorros diarios",
    "mb.b2d": "Ahorra cada día en tus comidas, compras y actividades.",
    "mb.b3t": "Cashback (próximamente)",
    "mb.b3d": "El cashback llegará pronto: acumularás recompensas en tus pedidos en línea en todos los restaurantes asociados Vytali.",
    "mb.b4t": "En tu monedero",
    "mb.b4d": "Tu tarjeta siempre a mano en Apple Wallet y Google Wallet.",
    "mb.ctaTitle": "¿Listo para ahorrar?",
    "mb.ctaText": "Únete a la comunidad Vytali y disfruta de todas las ventajas hoy.",
    "mb.bannerTitle": "Tarjeta de Miembro Vytali",
    "mb.bannerText": "Desbloquea promociones exclusivas con tu tarjeta de miembro Vytali.",
    "mb.bannerCta": "Hazte miembro",
    "mb.learnMore": "Saber más",
    "mbn.greeting": "Hola",
    "mbn.title": "¿Ya eres miembro Vytali?",
    "mbn.walletLabel": "tu Tarjeta de Miembro virtual está activa",
    "mbn.comingSoon": "Cashback próximamente en nuestros socios",
    "mbn.perk": "Tarjeta de Miembro virtual Vytali",
    "map.show": "Ver el mapa",
    "map.hide": "Ocultar el mapa",
    "map.view": "Ver",
    "map.youAreHere": "Estás aquí",
    "mbn.cta": "Activar mi tarjeta",

    "chat.title": "Asistente Vytali",
    "chat.subtitle": "En línea · respuesta inmediata",
    "chat.welcome": "¡Hola! 👋 Soy el asistente Vytali. Dime qué buscas (cocina, ciudad…) y te oriento hacia nuestros socios.",
    "chat.placeholder": "Escribe tu mensaje…",
    "chat.openLabel": "Chatea con nosotros",
    "chat.error": "Asistente no disponible temporalmente. Inténtalo de nuevo.",

    "header.partners": "Ser Socio",

    "partners.hero.badge": "Abierto a restaurantes, tiendas de alimentos, catering y cafés de Quebec",
    "partners.hero.title1": "Sé socio de ",
    "partners.hero.highlight": "Vytali",
    "partners.hero.title2": ".",
    "partners.hero.subtitle": "La alternativa quebequense a UberEats y DoorDash. Pedidos en línea, entrega en todo Quebec y 5% de cashback que hace que tus clientes vuelvan.",
    "partners.hero.cta": "Únete gratis",
    "partners.hero.social": "26 socios · Entrega en todo Quebec · POS Clover integrado",

    "partners.compare.title": "Vytali vs los gigantes americanos",
    "partners.compare.subtitle": "Compara lo que realmente obtienes, pedido tras pedido.",
    "partners.compare.metric": "Métrica",
    "partners.compare.vytali": "Vytali",
    "partners.compare.uber": "UberEats",
    "partners.compare.door": "DoorDash",
    "partners.compare.commission": "Comisión por pedido",
    "partners.compare.cashback": "Cashback al cliente",
    "partners.compare.effective": "Costo neto efectivo",
    "partners.compare.retention": "Retención cliente (1 año)",
    "partners.compare.money": "El dinero se queda en Quebec 🇨🇦",
    "partners.compare.support": "Soporte 100% en francés",
    "partners.compare.multi": "Multilingüe FR / EN / ES",
    "partners.compare.delivery": "Entrega en todo Quebec",
    "partners.compare.footnote": "Estimación basada en estudios de retención e-commerce y programas de cashback comparables (Rakuten, Fidélis). Los resultados varían según volumen, categoría y ubicación.",
    "partners.compare.revenueTitle": "Sobre 100 pedidos de 100$ / año",
    "partners.compare.revenueVytali": "Vytali neto",
    "partners.compare.revenueUber": "UberEats neto",
    "partners.compare.revenueDelta": "+39% de ingresos netos gracias al cashback",

    "partners.flywheel.title": "El poder del cashback Vytali",
    "partners.flywheel.subtitle": "El 5% de cada pedido vuelve a la Tarjeta Vytali de tu cliente. Vuelve. Ganas más.",
    "partners.flywheel.s1t": "1. El cliente hace un pedido",
    "partners.flywheel.s1d": "Usa vytalicartes.ca para hacer un pedido de 30$.",
    "partners.flywheel.s2t": "2. Gana 1,50$ de cashback",
    "partners.flywheel.s2d": "El 5% del importe se acredita automáticamente en su Tarjeta de Miembro Vytali.",
    "partners.flywheel.s3t": "3. Vuelve para usar su cashback",
    "partners.flywheel.s3d": "Motivado por su saldo, vuelve a pedir 2-3 veces más rápido.",
    "partners.flywheel.s4t": "4. Multiplicas tus ingresos",
    "partners.flywheel.s4d": "Mayor volumen de pedidos · relación duradera · cero dependencia de gigantes de EE.UU.",

    "partners.how.title": "Cómo funciona",
    "partners.how.subtitle": "En línea en 48 horas. Sin código. Sin compromiso.",
    "partners.how.s1t": "Inscripción gratuita",
    "partners.how.s1d": "Rellena el formulario. 2 minutos son suficientes.",
    "partners.how.s2t": "Validamos tu perfil",
    "partners.how.s2d": "Nuestro equipo quebequense te llama en 24h para finalizar.",
    "partners.how.s3t": "Personaliza tu vitrina",
    "partners.how.s3d": "Fotos, menú, horarios — todo en un panel sencillo.",
    "partners.how.s4t": "Recibe pedidos y entregas",
    "partners.how.s4d": "Directamente en tu POS Clover. Vytali gestiona la entrega.",

    "partners.benefits.title": "6 buenas razones para unirte a Vytali",
    "partners.b1t": "Comisión justa: 25%",
    "partners.b1d": "De los cuales 5% vuelve a TUS clientes. Costo neto efectivo: 20%, frente al 30% de UberEats.",
    "partners.b2t": "Entrega incluida en todo Quebec",
    "partners.b2d": "Contamos con una red de entrega probada — tú no gestionas nada.",
    "partners.b3t": "100% quebequense",
    "partners.b3d": "Equipo local, soporte en francés, el dinero se queda aquí. Sin oficina central en Texas.",
    "partners.b4t": "Cashback que fideliza",
    "partners.b4d": "Tus clientes ganan 5% en cada pedido — vuelven CONTIGO, no con otros.",
    "partners.b5t": "Multilingüe FR / EN / ES",
    "partners.b5d": "Turistas, expatriados, residentes: tu vitrina habla su idioma automáticamente.",
    "partners.b6t": "Panel simple, POS Clover",
    "partners.b6d": "Sube fotos, edita tu menú en 2 clics. Pedidos directos en tu Clover.",

    "partners.trust.title": "Ya confían en nosotros",
    "partners.trust.subtitle": "Una comunidad creciente de comercios quebequenses.",

    "partners.form.title": "Únete a Vytali",
    "partners.form.subtitle": "Rellena el formulario — te llamamos en 24 horas.",
    "partners.form.businessName": "Nombre del comercio",
    "partners.form.businessType": "Tipo de comercio",
    "partners.form.type.restaurant": "Restaurante",
    "partners.form.type.epicerie": "Tienda de alimentos",
    "partners.form.type.traiteur": "Catering",
    "partners.form.type.cafe_bar": "Café / Bar",
    "partners.form.type.autre": "Otro (food)",
    "partners.form.address": "Dirección",
    "partners.form.city": "Ciudad",
    "partners.form.contactName": "Tu nombre",
    "partners.form.phone": "Teléfono",
    "partners.form.email": "Correo",
    "partners.form.website": "Sitio web o Instagram (opcional)",
    "partners.form.message": "Cuéntanos sobre tu negocio (opcional)",
    "partners.form.submit": "Enviar mi candidatura",
    "partners.form.submitting": "Enviando…",
    "partners.form.success": "¡Candidatura enviada! Te contactaremos en 24h.",
    "partners.form.error": "No se pudo enviar. Revisa los campos.",
    "partners.form.rateLimited": "Demasiados intentos. Vuelve a intentar en una hora.",

    "partners.faq.title": "Preguntas frecuentes",
    "partners.faq.q1": "¿Cuánto cuesta inscribirse?",
    "partners.faq.a1": "La inscripción es 100% gratuita. Solo tomamos comisión sobre los pedidos recibidos a través de Vytali (25%, de los cuales 5% vuelve a tus clientes como cashback).",
    "partners.faq.q2": "¿En cuánto tiempo estará mi comercio en línea?",
    "partners.faq.a2": "24 a 48h después de tu candidatura. Nuestro equipo te llama, conectamos tu POS Clover y apareces en vytalicartes.ca.",
    "partners.faq.q3": "¿Puedo mantener UberEats y DoorDash en paralelo?",
    "partners.faq.a3": "Sí, totalmente. Vytali es complementario. Muchos socios mantienen los gigantes de EE.UU. y usan Vytali para construir una base fiel en Quebec.",
    "partners.faq.q4": "¿Cómo funciona la entrega?",
    "partners.faq.a4": "Vytali cubre todo Quebec con una red probada. Sin conductores que contratar, sin logística que gestionar.",
    "partners.faq.q5": "¿Cómo se calcula el cashback del cliente?",
    "partners.faq.a5": "El 5% del importe antes de impuestos de cada pedido en vytalicartes.ca se acredita automáticamente en la Tarjeta de Miembro Vytali. Este cashback lo financiamos nosotros, no tú.",
    "partners.faq.q6": "¿Mantengo el control de mis precios?",
    "partners.faq.a6": "Sí. Fijas tus precios, menús, horarios. Vytali nunca impone promociones ni precios mínimos.",

    "partners.finalcta.title": "¿Listo para el siguiente nivel?",
    "partners.finalcta.subtitle": "Únete al único marketplace de pedidos y entrega 100% quebequense.",
    "partners.finalcta.button": "Únete a Vytali ahora",

    "admin.tabs.applications": "Candidaturas",
    "admin.applications.empty": "Aún no hay candidaturas.",
    "admin.applications.contact": "Marcar contactado",
    "admin.applications.approve": "Aprobar",
    "admin.applications.reject": "Rechazar",
    "admin.applications.reset": "Volver a pendiente",
  },
};
